import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../../Styles/Modules/Display.module.scss';
import { formatToCustomLocale } from '../../utilities';

const Display = ({
  label,
  value,
  modifier,
}) => {
  const { t } = useTranslation();

  return (
    <div
      title={t(`${label}`)}
      className={`${styles.display} ${modifier ? styles[modifier] : ''}`}
    >
      {label && (
        <div className={styles.displayLabel}>
          {t(`${label}`)}
        </div>
      )}

      <div className={styles.displayValue}>
        {formatToCustomLocale(value)}
      </div>
    </div>
  );
};

export default Display;
